import { render, staticRenderFns } from "./ListCurrencies.vue?vue&type=template&id=8c9af8be&"
import script from "./ListCurrencies.vue?vue&type=script&lang=js&"
export * from "./ListCurrencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports